<template>
  <footer class="app-footer">
   <div class="container-fluid" style="padding-top:10px;">
     &copy; 2018-2025 <a href="https://www.cpu-net.co.jp" target="_blank">CPU Inc.</a>
     <div class="row" style="padding-top:10px;padding-bottom:10px;">
        <div class="col-md">
          株式会社シーピーユー
        </div>
        <div class="col-md">
          〒921-8043 石川県金沢市西泉4-60
        </div>
        <div class="col-md">
          お問い合わせは <a href="https://www.cpu-net.co.jp/form/user_contact.html" target="_blank">こちら</a>
        </div>
     </div>
   </div>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>

<style scoped>
a:link { color:#23527c; }
a:visited { color: #23527c; }
.container-fluid{
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue